import React, { useState, useEffect } from "react";
import { Box, Typography, Tabs, Tab, Paper } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import CollectionCenter from "./collectionCenter/index";
import Employee from "./employee/index";
import ReferringDoctor from "./referringDoctor/index";

const NewLabSettings = () => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const tabConfigs = [
    { label: "Collection Center", key: "collection-center" },
    { label: "Employee", key: "employee" },
    { label: "Referring Doctors", key: "referring-doctors" },
  ];

  const visibleTabMap = tabConfigs.reduce((acc, item, index) => {
    acc[item.key] = index;
    return acc;
  }, {} as Record<string, number>);

  const initialTabIndex = tab ? visibleTabMap[tab] ?? 0 : 0;
  const [tabIndex, setTabIndex] = useState<number>(initialTabIndex);

  useEffect(() => {
    if (tab !== undefined && visibleTabMap[tab] !== undefined) {
      const targetIndex = visibleTabMap[tab];
      setTabIndex(targetIndex);
    }
  }, [tab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabKey = tabConfigs[newValue].key;
    let path = `/lab-settings/${tabKey}`;
    navigate(path, { replace: true });
    setTabIndex(newValue);
  };

  const renderTabContent = () => {
    const key = tabConfigs[tabIndex]?.key;

    switch (key) {
      case "collection-center":
        return <CollectionCenter />;
      case "employee":
        return <Employee />;
      case "referring-doctors":
        return <ReferringDoctor />;
      default:
        return <CollectionCenter />;
    }
  };

  return (
    <Box sx={{ width: "100%", p: 1 }}>
      <Paper elevation={3} sx={{ p: 2 }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          allowScrollButtonsMobile
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTabs-flexContainer": {
              display: "flex",
              gap: 1,
              justifyContent: "start",
            },
            "& .MuiTab-root": {
              color: "#4d4d4dff",
              textTransform: "none",
              padding: "6px 16px",
              minWidth: "auto",
              fontWeight: "400",
            },
            "& .Mui-disabled": {
              color: "#9e9e9edc !important",
              cursor: "not-allowed",
            },
            "& .Mui-selected": {
              color: "primary.main",
            },
          }}
        >
          {tabConfigs.map(tab => (
            <Tab
              key={tab.key}
              label={tab.label}
              sx={{ fontSize: ".875rem", pointerEvents: "auto" }}
            />
          ))}
        </Tabs>

        <Box sx={{ marginTop: "20px" }}>{renderTabContent()}</Box>
      </Paper>
    </Box>
  );
};

export default NewLabSettings;
